export default `
# Konference - Výchova k životu.

## inteligence.  osobnost.  radost ze života.

03-04 Březen 2018 | Hotel Voroněž Brno

*Dva dny spojující rodiče a děti*

**Výchova k životu** je největší interaktivní česko-slovenská konference o výchově a vzdělávání dětí a jejich rodičů. Chceme vytvořit prostor, kde se relevantní informace o výchově a vzdělávání dostanou k rodičům a učitelům základních a mateřských škol.

Konference se koná **pod záštitou města Brno**.

- Jak být pro dítě dobrým rodičem?
- Mohu se svým dítětem dobře vycházet i bez boje?
- Jak vychovávat dítě, aby v rodině zavládl klid i v pubertě?
- Jak být pro své dítě dobrým příkladem ve vztahu, v manželství, v rodičovství?

Mnoho praktických informací na jednom místě od špičkových odborníků na výchovu a psychologii.


Zažijete dva dny nabité informacemi o výchově skrze:

- přednášky a prostor na diskuzi s odborníky, kteří rodičům rozumějí
- interaktivní diskuze - při tematických stolech se setkají rodiče, psychologové, dětští lékaři...
- encounterové skupiny
- řešitelské skupiny se zaměřením na konkrétní otázky
- workshopy v menších skupinkách zaměřené na praktické řešení problémů
- vzájemnou pomoc mezi rodiči se skutečnými dotazy po celý čas konference a i následnou podporou po konferenci
- typy na další vzdělávání od lektorů, organizátorů i vystavovatelů
- prezentace zajímavých smysluplných hraček, vzdělávacích pomůcek, knih, výrobků pro děti.
- doprovodný program na večer
`



// WEBPACK FOOTER //
// ./src/content/devdata/about/text.js